import React, { useState } from "react";

import Button from "../Button/Button";

import "./PrecisionCoursingJudgeBooksFilterModal.scss";

interface IProps {
  onDownload: (sortOrder: "height_at_withers" | "armband") => void;
  onCancel: () => void;
}

const PrecisionCoursingJudgeBooksFilterModal: React.FC<IProps> = (props) => {
  const [sortOrder, setSortOrder] = useState<"height_at_withers" | "armband">("height_at_withers");

  return (
    <div className="precision-coursing-judge-books-filter-modal">
      <h2>Judge's Books Sort Order</h2>
      <p>Choose how entries are ordered in the printed judge's books.</p>

      <div className="sort-options">
        <div
          className={`sort-option ${sortOrder === "height_at_withers" ? "selected" : ""}`}
          onClick={() => setSortOrder("height_at_withers")}
        >
          <input
            type="radio"
            id="sortHeight"
            name="sortOrder"
            checked={sortOrder === "height_at_withers"}
            onChange={() => setSortOrder("height_at_withers")}
          />
          <div className="option-content">
            <div className="option-title">Height at the Withers</div>
            <div className="option-description">Entries listed from smallest to largest measured height</div>
          </div>
        </div>

        <div
          className={`sort-option ${sortOrder === "armband" ? "selected" : ""}`}
          onClick={() => setSortOrder("armband")}
        >
          <input
            type="radio"
            id="sortArmband"
            name="sortOrder"
            checked={sortOrder === "armband"}
            onChange={() => setSortOrder("armband")}
          />
          <div className="option-content">
            <div className="option-title">Armband Number</div>
            <div className="option-description">Entries listed in ascending armband number order</div>
          </div>
        </div>
      </div>

      <div className="modal-actions">
        <Button className="cancel" onClick={props.onCancel} type="button">Cancel</Button>
        <Button onClick={() => props.onDownload(sortOrder)} type="button">Download</Button>
      </div>
    </div>
  );
};

export default PrecisionCoursingJudgeBooksFilterModal;
